export default __webpack_public_path__ + "static/media/yellowCheckHeart.f96b6449.svg";